import React, { PureComponent, PropTypes } from 'react';

export default class Item extends PureComponent {
    static propTypes = {
        id: PropTypes.number,
        text: PropTypes.string,
        subtext: PropTypes.string,
        isSelected: PropTypes.bool.isRequired,
        onClick: PropTypes.func,
    }

    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);
    }

    onClick() {
        if (!this.props.onClick)
            return;

        const { id, text } = this.props;
        this.props.onClick(isNaN(id) ? null : id, text);
    }

    getDefaultItemJsx(selectedCssClass) {
        const { text, subtext } = this.props;

        let subTextJsx;
        if (subtext) {
            subTextJsx = (
                <div className={`sub-text ${selectedCssClass}`}>
                    {subtext}
                </div>
            );
        }

        return (
            <div className="text">
                {text}
                {subTextJsx}
            </div>
        );
    }

    render() {
        const { isSelected, onClick, children } = this.props;

        const selectedCssClass = isSelected ? `selected` : ``;
        const selectedIconJsx = isSelected ? <span className="icon"><i className="material-icons">&#xE5CA;</i></span> : null;

        let innerJsx = children;
        if (!innerJsx) {
            innerJsx = this.getDefaultItemJsx(selectedCssClass);
        }

        return (
            <li
                className={`item ${selectedCssClass}`}
                onClick={this.onClick}
            >
                {innerJsx}
                {selectedIconJsx}
            </li>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Common/SelectList/Item.jsx